import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequestProductSales } from "shared/utils/fetch-api";

export const fetchCountries = createAsyncThunk(
    'contract/fetchCountries',
    async ({
        AgentSalesDataID,
    }: {
        AgentSalesDataID: string;
    }, { rejectWithValue }) => {
        const requestBody = {
            "AgentSalesDataID": AgentSalesDataID,
            "Source": "Site",
        }
        try {
            const response = await getRequestProductSales(requestBody, 'product-sales', 'getCountries', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    Countries: data.Countries
                };
            } else {
                return data.Errors;
            }
        } catch (error: any) {
            return error.message;
        }
    }
);

export const fetchDaDataAddres = createAsyncThunk(
    'contract/fetchDaDataAddres',
    async ({
        Text,
         AgentSalesDataID,
    }: {
        Text: string;
         AgentSalesDataID: string;
    }, { rejectWithValue }) => {
        const requestBody = {
            "AgentSalesDataID": AgentSalesDataID,
            "Source": "Site",
            "Text": Text
        }
        try {
            const response = await getRequestProductSales(requestBody, 'product-sales', 'getDaDataAddress', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    Suggestions: data.Suggestions
                };
            } else {
                return data.Errors;
            }
        } catch (error: any) {
            return error.message;
        }
    }
);

